import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Spacer } from "../components/spacer";
import { LanguageSwitch } from "../../components/language-switch";

interface Props {
    show: boolean;
}

export default function PasswordSendDialog({ show }: Props) {
    const { t } = useTranslation();
    return (
        <Modal
            className="warning-modal"
            show={show}
            onHide={() => {
                window.location.href = "/";
            }}
        >
            <Modal.Header closeButton className="border-bottom-0" />
            <Modal.Body className="padding-left-4 padding-right-4">
                <div className="text-center">
                    <div
                        className="login-header-text"
                        style={{ fontSize: "18px" }}
                    >
                        {t("login.reset_send_success")}
                    </div>
                    <div
                        className="text-lg"
                        style={{ padding: "8px", fontSize: "14px" }}
                    >
                        {t("login.password_reset_text_1")} <br />
                        {t("login.password_reset_text_2")}
                    </div>
                    <div className="text-center m-auto language-switch-container">
                        <LanguageSwitch />
                    </div>
                    <Spacer height={20} />
                </div>
            </Modal.Body>
        </Modal>
    );
}
